import { extractNumbersFromMerchantId } from '@if/core/utils'
export const ICEBERG_ID = '419' // TODO : WHAT IS DEFAULT ID? THIS IS THE ID FOR "ICEBERG FINANCE (TEST DEMO)"

export function isIcebergMerchant(merchantId: string) {
  const id = extractNumbersFromMerchantId(merchantId)
  return id === ICEBERG_ID
}
